import React from 'react';

export const ClockIcon: React.FC<sharedComponents.SvgIcon> = ({ height = 24, width = 24, className = '' }) => (
  <svg
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 24 24"
    className={className}
  >
    <path fill="#4C4C4C" d="M12.5 22.488A10.489 10.489 0 1 1 22.988 12 10.5 10.5 0 0 1 12.5 22.488Zm0-20.226A9.738 9.738 0 1 0 22.238 12 9.75 9.75 0 0 0 12.5 2.262Z" />
    <path fill="#000" d="M16.695 11.633h-3.81V6.39a.375.375 0 1 0-.75 0v5.994h4.56a.375.375 0 1 0 0-.75Z" />
  </svg>
);
